import {
  Component,
  Input,
  OnInit,
  Optional,
  Self,
  OnChanges,
  SimpleChanges,
  Output,
  EventEmitter,
} from '@angular/core';
import { NgControl } from '@angular/forms';
import { ControlValueAccessor, FormBuilder } from '@ngneat/reactive-forms';
import * as _ from 'lodash';

import { NestedFormComponent } from '@digital-platform/shared/ui';
import { Item } from '../waste-component-row/waste-component-row.component';

@Component({
  selector: 'digital-platform-waste-component-rows',
  templateUrl: './waste-component-rows.component.html',
  styleUrls: ['./waste-component-rows.component.scss'],
})
export class WasteComponentRowsComponent
  extends NestedFormComponent<Item[], { items: Item[] }>
  implements OnInit, ControlValueAccessor<Item[]>, OnChanges
{
  @Input() showPpm = false;
  @Input() tabIndex = 1;
  @Input() isToggled = false;
  @Input() sum: number;
  @Input() labels: any;
  @Input() isRequired = true;
  @Input() isLegacy = false;
  @Output() lastTabIndex = new EventEmitter<number>();

  public onTouched: () => void;
  public rowCount = 0;

  public form;

  public readonly DEFAULT_VALUE = { items: [] };
  private readonly DEFAULT_ROW = {
    name: null,
    typicalOrActual: null,
    min: null,
    max: null,
    unitOfMeasure: 'percent',
  };

  _onChange: (value: any) => void;

  constructor(
    @Optional() @Self() public controlDir: NgControl,
    private readonly fb: FormBuilder
  ) {
    super(controlDir);
    this.value = this.mapOutputValue(this.DEFAULT_VALUE);

    this.form = this.fb.group({
      items: this.fb.array<Item>(Array(5).fill(this.DEFAULT_ROW)),
    });
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  ngOnChanges(simpleChange: SimpleChanges) {
    if (simpleChange.isRequired?.currentValue) {
      this.isRequired = simpleChange.isRequired.currentValue;
    }
  }

  addItem(item = this.DEFAULT_ROW) {
    this.inc();
    this.formArray.push(this.fb.control<Item>(item));
    this.lastTabIndex.emit(this.tabIndex + this.rowCount + 3 + 1);
  }

  get formArray() {
    return this.form.get('items');
  }

  public writeValue(value: Item[]): void {
    if (value) {
      this.formArray.clear();
      value.forEach((item) => this.addItem(item));
    }
  }

  public mapInputValue(items) {
    return { items };
  }

  public mapOutputValue(value) {
    return value.items;
  }

  deleteRow(index: number) {
    this.dec();
    this.formArray.removeAt(index);
  }
  inc() {
    this.rowCount = this.rowCount + 1;
  }
  dec() {
    //this.rowCount - 1 < 0 ? 0 : this.rowCount - 1;
    this.rowCount = this.rowCount - 1;
  }
}
